// import './home.scss';

const NoPage = () => {
  return <h1>Le erraste al dedazo</h1>;
};

export default NoPage;
